module.exports = __webpack_public_path__ + "img/avatar-4.e0ab315a.jpg";